module.exports = __webpack_public_path__ + "static/media/loading.a4c3b714.gif";